import { render } from "./ThePositions.vue?vue&type=template&id=e2d9388a&ts=true"
import script from "./ThePositions.vue?vue&type=script&lang=ts"
export * from "./ThePositions.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__